import { LocalDate } from '@js-joda/core';

import {
   PregnancyCompletionCreateCommand,
   PregnancyCompletionType,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { FormContextValues } from '@dreryk/react-common';
import { ButtonVariant, ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { gynecologicalInterviewTranslationKeys } from '../../translations';

type GynecologicalInterviewPregnancyCompletionSubmitValues = {
   completionDate: LocalDate | null;
   description: string | null;
};

type GynecologicalInterviewPregnancyCompletionActionProps = {
   readonly handleSubmit: FormContextValues<GynecologicalInterviewPregnancyCompletionSubmitValues>['handleSubmit'];
   readonly medicalInformationId: number;
   readonly pregnancyCompletionType: PregnancyCompletionType;
   readonly patientId: number;
   readonly onSuccess: VoidFunction;
   readonly registerMedicalEvent: boolean;
};

export const GynecologicalInterviewPregnancyCompletionAction = (
   props: GynecologicalInterviewPregnancyCompletionActionProps
): JSX.Element => {
   const { executeAsync: completePregnancy } = useCqrsCommand<
      void,
      GynecologicalInterviewPregnancyCompletionSubmitValues
   >(
      (parameters) => {
         const command = new PregnancyCompletionCreateCommand();
         command.patientId = props.patientId;
         command.description = Choice.withUseDefaultIfNull(parameters.description ?? null);
         command.completionDate = Choice.withUseDefaultIfNull(parameters.completionDate ?? null);
         command.completionType = props.pregnancyCompletionType;
         command.medicalInformationId = props.medicalInformationId;
         command.registerMedicalEvent = props.registerMedicalEvent;
         return command;
      },
      {
         onSuccess: props.onSuccess,
      }
   );

   return (
      <ModalConfirmButton
         testId={props.registerMedicalEvent ? 'completePregnancyAndSendToP1' : 'completePregnancy'}
         label={
            props.registerMedicalEvent
               ? gynecologicalInterviewTranslationKeys.addEntryAndSendToP1
               : gynecologicalInterviewTranslationKeys.addEntry
         }
         onClick={props.handleSubmit(completePregnancy)}
         variant={props.registerMedicalEvent ? ButtonVariant.SECONDARY : ButtonVariant.PRIMARY}
      />
   );
};
